(function () {
    $(function () {
        
        $(".js-events-list").each( function () {
            const $wrap = $(this);
            const $itemsContainer = $wrap.find(".js-events-list__container");
            
            const $btnWrap = $wrap.find(".js-events-list__showMore-wrap");
            const $btn = $btnWrap.find(".js-events-list__showMore");
            
            let curDay;
            let curMonth;
            let curYear;
            let curCityId;
            
            let datePicked = false;
            
            let timer;
            
            const ajaxUrlGetItems = $wrap.data("ajax-url-get-items");
            
            const itemsChangeTimeout = 500;
            
            if ($itemsContainer.length === 0) return false;
    
            // разбор даты
            const date = new Date();
    
            // стартовая дата
            curDay = date.getDate();
            curMonth = date.getMonth();
            curYear = date.getFullYear();
    
            curCityId = $wrap.data("city-default");
            
    
            $btn.on("click", function (e) {
                e.preventDefault();
    
                clearTimeout(timer);
                
                timer = setTimeout( function () {
                    const errData = {
                        title: "Произошла ошибка!",
                        text: ""
                    };
    
                    const offset = $itemsContainer.find(".js-events-list__item").length;
        
                    // -------
                    // #FAKEDATA
        
                    // const fakeResponse = {
                    //
                    //     success: true,
                    //     showMore: false,
                    //     items: [
                    //         "<div class=\"event-list-item\">\n" +
                    //         "    <div class=\"event-list-item__left\"><span class=\"event-list-item__left-date\">12.09</span><span class=\"event-list-item__left-time\">18:30</span></div>\n" +
                    //         "\n" +
                    //         "    <div class=\"event-list-item__right\">\n" +
                    //         "        <a href=\"#\">\n" +
                    //         "            <picture class=\"event-list-item-picture\">\n" +
                    //         "                <source srcset=\"img/media/events-home/event_image3.jpg 3x, img/media/events-home/event_image3@2x.jpg 2x, img/media/events-home/event_image3.jpg\">\n" +
                    //         "                <img src=\"img/media/events-home/event_image3.jpg\">\n" +
                    //         "            </picture>\n" +
                    //         "        </a>\n" +
                    //         "\n" +
                    //         "        <div class=\"event-list-item-description\">\n" +
                    //         "            <div class=\"event-list-item-description__title\"><a href=\"#\">Максим Жегалин</a></div>\n" +
                    //         "            <div class=\"event-list-item-description__text\">Встреча состоится в рамках Московской международной книжной выставки-ярмарки</div>\n" +
                    //         "            <div class=\"event-list-item-description__place\">Москва, ВДНХ, павильон № 75, Стенд «Эксмо» Т45</div>\n" +
                    //         "        </div>\n" +
                    //         "    </div>\n" +
                    //         "</div>",
                    //
                    //         "<div class=\"event-list-item\">\n" +
                    //         "    <div class=\"event-list-item__left\"><span class=\"event-list-item__left-date\">12.09</span><span class=\"event-list-item__left-time\">18:30</span></div>\n" +
                    //         "\n" +
                    //         "    <div class=\"event-list-item__right\">\n" +
                    //         "        <a href=\"#\">\n" +
                    //         "            <picture class=\"event-list-item-picture\">\n" +
                    //         "                <source srcset=\"img/media/events-home/event_image2.jpg 3x, img/media/events-home/event_image2@2x.jpg 2x, img/media/events-home/event_image2.jpg\">\n" +
                    //         "                <img src=\"img/media/events-home/event_image2.jpg\">\n" +
                    //         "            </picture>\n" +
                    //         "        </a>\n" +
                    //         "\n" +
                    //         "        <div class=\"event-list-item-description\">\n" +
                    //         "            <div class=\"event-list-item-description__title\"><a href=\"#\">Юрий Вяземский</a></div>\n" +
                    //         "            <div class=\"event-list-item-description__text\">Встреча состоится в рамках Московской международной книжной выставки-ярмарки</div>\n" +
                    //         "            <div class=\"event-list-item-description__place\">Москва, ВДНХ, павильон № 75, Стенд «Эксмо» Т45</div>\n" +
                    //         "        </div>\n" +
                    //         "    </div>\n" +
                    //         "</div>"
                    //     ]
                    // };
                    //
                    // let response = fakeResponse;
                    //
                    // if (response.success === true) {
                    //
                    //     if (response.items.length > 0) {
                    //         appendData(response.items, response.showMore);
                    //     } else {
                    //         $btnWrap.addClass("_hidden");
                    //     }
                    //
                    // }
                    //
                    // return false;
        
                    // -------
        
                    let promise;
                    
                    if (datePicked)
                        promise = getItemsAjax(ajaxUrlGetItems, curCityId, offset, curDay, curMonth, curYear );
                    else
                        promise = getItemsAjax(ajaxUrlGetItems, curCityId, offset );
                    
                    promise
                        .done(function(response) {
                            if (response.success === true) {
        
                                if (response.items.length > 0) {
                                    appendData(response.items, response.showMore);
                                } else {
                                    $btnWrap.addClass("_hidden");
                                }
                                
                            } else {
                                $(document).trigger('is:errorModal', errData);
                            }
                        })
                        .fail(function(jqXHR, textStatus, errorThrown) {
                            $(document).trigger('is:errorModal', errData);
                        });
    
                }, itemsChangeTimeout);
            });
    
            $(document).on('is:change', '.events-cities', function (e, cityId) {
                clearTimeout(timer);
                
                curCityId = cityId;
                
                if (datePicked)
                    resetItems(cityId, curDay, curMonth, curYear);
                else
                    resetItems(cityId);
            });
    
            $(document).on('is:set', '.events-calendar', function (e, d, m, y) {
                clearTimeout(timer);
    
                curDay = d;
                curMonth = m;
                curYear = y;
    
                datePicked = true; // дату выбрали
    
                resetItems(curCityId, d, m, y);
            });
            
            
            
            function getItemsAjax (ajaxUrl, cityId, offset = 0, d = false, m = false, y = false) {
                
                let ajaxData;
                
                if ( d !== false && m !== false && y !== false ) {
                    const mFormatted = m + 1;
                    const dateVal = ((d < 10 ) ? "0"+d : ""+d) + "." + ((mFormatted < 10 ) ? "0"+mFormatted : ""+mFormatted) + "." + y;
    
                    ajaxData = {
                        date: dateVal,
                        cityId: cityId,
                        offset: offset
                    };
                    
                } else {
                    ajaxData = {
                        cityId: cityId,
                        offset: offset
                    };
                }
    
                return $.ajax({
                    method: 'POST',
                    url: ajaxUrl,
                    data: JSON.stringify(ajaxData),
                    dataType: 'json'
                });
            }
            
            function resetItems (cityId, d = false, m = false, y = false) {
                
                timer = setTimeout( function () {
                    $itemsContainer.html("");
        
                    const errData = {
                        title: "Произошла ошибка!",
                        text: ""
                    };
        
                    // -------
                    // #FAKEDATA
        
                    // const fakeResponse = {
                    //
                    //     success: true,
                    //     showMore: false,
                    //     items: [
                    //         "<div class=\"event-list-item\">\n" +
                    //         "    <div class=\"event-list-item__left\"><span class=\"event-list-item__left-date\">12.09</span><span class=\"event-list-item__left-time\">18:30</span></div>\n" +
                    //         "\n" +
                    //         "    <div class=\"event-list-item__right\">\n" +
                    //         "        <a href=\"#\">\n" +
                    //         "            <picture class=\"event-list-item-picture\">\n" +
                    //         "                <source srcset=\"img/media/events-home/event_image3.jpg 3x, img/media/events-home/event_image3@2x.jpg 2x, img/media/events-home/event_image3.jpg\">\n" +
                    //         "                <img src=\"img/media/events-home/event_image3.jpg\">\n" +
                    //         "            </picture>\n" +
                    //         "        </a>\n" +
                    //         "\n" +
                    //         "        <div class=\"event-list-item-description\">\n" +
                    //         "            <div class=\"event-list-item-description__title\"><a href=\"#\">Максим Жегалин</a></div>\n" +
                    //         "            <div class=\"event-list-item-description__text\">Встреча состоится в рамках Московской международной книжной выставки-ярмарки</div>\n" +
                    //         "            <div class=\"event-list-item-description__place\">Москва, ВДНХ, павильон № 75, Стенд «Эксмо» Т45</div>\n" +
                    //         "        </div>\n" +
                    //         "    </div>\n" +
                    //         "</div>",
                    //
                    //         "<div class=\"event-list-item\">\n" +
                    //         "    <div class=\"event-list-item__left\"><span class=\"event-list-item__left-date\">12.09</span><span class=\"event-list-item__left-time\">18:30</span></div>\n" +
                    //         "\n" +
                    //         "    <div class=\"event-list-item__right\">\n" +
                    //         "        <a href=\"#\">\n" +
                    //         "            <picture class=\"event-list-item-picture\">\n" +
                    //         "                <source srcset=\"img/media/events-home/event_image2.jpg 3x, img/media/events-home/event_image2@2x.jpg 2x, img/media/events-home/event_image2.jpg\">\n" +
                    //         "                <img src=\"img/media/events-home/event_image2.jpg\">\n" +
                    //         "            </picture>\n" +
                    //         "        </a>\n" +
                    //         "\n" +
                    //         "        <div class=\"event-list-item-description\">\n" +
                    //         "            <div class=\"event-list-item-description__title\"><a href=\"#\">Юрий Вяземский</a></div>\n" +
                    //         "            <div class=\"event-list-item-description__text\">Встреча состоится в рамках Московской международной книжной выставки-ярмарки</div>\n" +
                    //         "            <div class=\"event-list-item-description__place\">Москва, ВДНХ, павильон № 75, Стенд «Эксмо» Т45</div>\n" +
                    //         "        </div>\n" +
                    //         "    </div>\n" +
                    //         "</div>"
                    //     ]
                    // };
                    //
                    // let response = fakeResponse;
                    //
                    // console.log(response);
                    //
                    // if (response.success === true) {
                    //     appendData(response.items, response.showMore);
                    // }
                    //
                    // return false;
        
                    // -------
    
                    let promise;
    
                    if ( d !== false && m !== false && y !== false )
                        promise = getItemsAjax(ajaxUrlGetItems, cityId, 0, d, m, y);
                    else
                        promise = getItemsAjax(ajaxUrlGetItems, cityId);
        
                    promise
                        .done(function(response) {
                            if (response.success === true) {
                                appendData(response.items, response.showMore);
                                setTimeout(function() {
                                    let lazyLoadPage = new LazyLoad({
                                        elements_selector: '.lazy',
                                        unobserve_entered: true,
                                        unobserve_completed: true
                                    })
                                    lazyLoadPage.update();
                                    console.log(2);
                                }, 1000);
                            } else {
                                $(document).trigger('is:errorModal', errData);
                            }
                        })
                        .fail(function(jqXHR, textStatus, errorThrown) {
                            $(document).trigger('is:errorModal', errData);
                        });
                }, itemsChangeTimeout);
            }
            
            function appendData (items = [], more = false) {
                $.each(items, function (i, itemHtml) {
                    appendItem(itemHtml);
                });
                
                if (more) {
                    $btnWrap.removeClass("_hidden");
                } else {
                    $btnWrap.addClass("_hidden");
                }
            }
            
            function appendItem (itemHtml) {
                const appendHtml = "<div class=\"events-items-container__item js-events-list__item\">" + itemHtml + "</div>";
                
                $itemsContainer.append(appendHtml);
            }
        });
    });
    
    
    
    
    
    
    // календарь
    
    $(function () {
        
        $(".js-calendar").each( function () {
            const $_this = $(this);
            const $outWrap = $_this.find(".js-calendar__m");
            const $daysWrap = $_this.find(".js-calendar__days");
            
            const ajaxUrlDays = $_this.data("ajax-url-days");
    
            // критичные для инициализации элементы
            
            if ($outWrap.length === 0) return false;
            if ($daysWrap.length === 0) return false;
            if (!ajaxUrlDays) return false;
            
            
            // константы дат
            const arDays = { 1: "пн", 2: "вт", 3: "ср", 4: "чт", 5: "пт", 6: "сб", 0: "вс" };
            const arMonths = [ "январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь" ];
            
            // настройки
            const clickArrowTimeout = 250;
            
            // таймер кликов по стрелкам
            let clickTimer;
            
            // разбор даты
            const date = new Date();
            
            // стартовая дата
            const nowDay = date.getDate();
            const nowMonth = date.getMonth();
            const nowYear = date.getFullYear();
            
            // текущая выбранная дата
            let curDay = nowDay;
            let curMonth = nowMonth;
            let curYear = nowYear;
            
            // текущий показанный месяц
            let shownMonth = curMonth;
            let shownYear = curYear;
            
            
            // разметка элементов
            const arrowSvg =
                "<svg width=\"20\" height=\"10\" viewBox=\"0 0 20 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
                "    <path d=\"M0 4.99704C0 4.44216 0.447178 3.99235 0.998799 3.99235H18.9772C19.5288 3.99235 19.976 4.44216 19.976 4.99704C19.976 5.55191 19.5288 6.00173 18.9772 6.00173H0.9988C0.447178 6.00173 0 5.55191 0 4.99704Z\"/>\n" +
                "    <path d=\"M14.2992 0.28875C14.6862 -0.09625 15.3136 -0.0962499 15.7006 0.28875L19.6853 4.2529C20.0723 4.6379 20.0723 5.26211 19.6853 5.64711C19.2983 6.03211 18.6708 6.03211 18.2839 5.64711L14.2992 1.68296C13.9122 1.29796 13.9122 0.673749 14.2992 0.28875Z\"/>\n" +
                "    <path d=\"M19.7098 4.32328C19.3228 3.93828 18.6953 3.93828 18.3083 4.32328L14.2939 8.31704C13.9069 8.70204 13.9069 9.32625 14.2939 9.71125C14.6809 10.0963 15.3083 10.0963 15.6953 9.71125L19.7098 5.71748C20.0968 5.33249 20.0968 4.70828 19.7098 4.32328Z\"/>\n" +
                "</svg>";
    
            // вывод месяца и года
            $outWrap.append("<div class=\"b-calendar__months-name\"><span class=\"b-calendar__months-name--span js-calendar__out-m\"></span> <span class=\"b-calendar__months-name--span js-calendar__out-y\"></span></div>");
            const $outMonth = $outWrap.find(".js-calendar__out-m");
            const $outYear = $outWrap.find(".js-calendar__out-y");
            
            // кнопка переключения календаря назад
            $outWrap.prepend("<button class=\"b-calendar__months-btn js-calendar__m-prev _prev\">" + arrowSvg + "</button>");
            const $btnPrev = $outWrap.find(".js-calendar__m-prev");
    
            // кнопка переключения календаря вперёд
            $outWrap.append("<button class=\"b-calendar__months-btn js-calendar__m-next _next\">" + arrowSvg + "</button>");
            const $btnNext = $outWrap.find(".js-calendar__m-next");
            
            // шапка с названиями дней
            $daysWrap.append("<div class=\"b-calendar__days-head js-calendar__days-header\"></div>");
            const $daysHeader = $daysWrap.find(".js-calendar__days-header");
            
            // контейнер для дней
            $daysWrap.append("<div class=\"b-calendar__days-body js-calendar__days-cells\">");
            const $daysContainer = $daysWrap.find(".js-calendar__days-cells");
            
            
            // Отрисовка
            init();
            
            
            // клик на месяц вниз
            $btnPrev.on("click", function (e) {
                e.preventDefault();
    
                clearTimeout(clickTimer);
                monDecrease(true);
            });
    
            // клик на месяц вверх
            $btnNext.on("click", function (e) {
                e.preventDefault();
    
                clearTimeout(clickTimer);
                monIncrease(true);
            });
            
            $(document).on("click", ".js-calendar__days-cells--item", function (e) {
                e.preventDefault();
                
                const $_this = $(this);
    
                if ( !($_this.hasClass("_has-events")) ) {
                    return false;
                }
                
                $daysContainer.find(".js-calendar__days-cells--item").removeClass("_chosen");
                $_this.addClass("_chosen");
                
                curDay = $_this.data("day-num");
                curMonth = shownMonth;
                curYear = shownYear;
    
                $_this.trigger("is:set", [curDay, curMonth, curYear]);
            });
    
            $daysContainer.on("scroll", function (e) {
                clearTimeout($.data(this, "daysScrollTimer"));
                $.data(this, "daysScrollTimer", setTimeout(function() {
                    compensateScroll();
                }, 250));
            });
            
            
            function init () {
                outputMonYear(nowMonth, nowYear);
                outputDaysNames();
                outputMonthData(nowMonth, nowYear, true);
            }
            
            
            // изменения месяца
            
            // к более давнему
            function monDecrease (doTimeout = false) {
                let newMonth = shownMonth - 1;
                let newYear = shownYear;
                if (newMonth < 0) {
                    newMonth = 11;
                    newYear--;
                }
    
                shownMonth = newMonth;
                shownYear = newYear;
    
                outputMonYear(shownMonth, shownYear);
    
                if (doTimeout) {
                    clickTimer = setTimeout( function () {
                        outputMonthData(shownMonth, shownYear);
                    }, clickArrowTimeout );
                } else {
                    outputMonthData(shownMonth, shownYear);
                }
            }
    
            // к более новому
            function monIncrease (doTimeout = false) {
                let newMonth = shownMonth + 1;
                let newYear = shownYear;
                if (newMonth > 11) {
                    newMonth = 0;
                    newYear++;
                }
    
                shownMonth = newMonth;
                shownYear = newYear;
    
                outputMonYear(shownMonth, shownYear);
    
                if (doTimeout) {
                    clickTimer = setTimeout( function () {
                        outputMonthData(shownMonth, shownYear);
                    }, clickArrowTimeout );
                } else {
                    outputMonthData(shownMonth, shownYear);
                }
            }
            
            
            // компенсация скролла на мобилах
            
            function compensateScroll () {
                const winWidth = window.innerWidth;
                if (winWidth <= globObj.breakpoints.md) {
                    $daysContainer.find(".js-calendar__days-cells--item").each( function (i, item) {
                        if ($(item).position().left > 0) {
                            
                            $daysContainer.scrollLeft( $daysContainer.scrollLeft() - $(item).position().left );
                            
                            return false;
                        }
                    });
                }
            }
            
            
            // вывод данных
            
            function outputMonYear (m, y) {
                $outMonth.text(arMonths[m]);
                $outYear.text(y);
            }
            
            function outputDaysNames (start = 1) {
                let html = "";
                
                for (let i = start; i <= 6; i++) {
                    html += "<span class=\"b-calendar__days-head--item\">" + arDays[i] + "</span>";
                }
                
                if (start !== 0) {
                    html += "<span class=\"b-calendar__days-head--item\">" + arDays[0] + "</span>";
                }
                
                if (start > 1) {
                    for (let j = 1; j < start; j++) {
                        html += "<span class=\"b-calendar__days-head--item\">" + arDays[j] + "</span>";
                    }
                }
    
                $daysHeader.append(html);
            }
            
            function outputMonthData (m, y, isInit = false) {
                
                // ---------
                // #FAKEDATA
                
                // const arVariants = [ [5, 7, 10, 19, 22, 24, 27], [8, 11, 13, 20, 24, 25], [1, 10, 26], [15, 18] ];
                //
                // let fakeResponse = {};
                //
                // fakeResponse.success = true;
                // fakeResponse.daysNotEmpty = arVariants[Math.floor(Math.random() * arVariants.length)];
                //
                // const response = fakeResponse;
                //
                // outputDaysCells(m, y, ( response.daysNotEmpty && response.daysNotEmpty.length > 0 ) ? response.daysNotEmpty : [] );
                //
                // return false;
                
                // ----------
    
                const ajaxData = {
                    month: m + 1,
                    year: y
                };

                const promise = $.ajax({
                    method: 'POST',
                    url: ajaxUrlDays,
                    data: JSON.stringify(ajaxData),
                    dataType: 'json'
                });

                const errData = {
                    title: "Произошла ошибка!",
                    text: ""
                };

                promise
                    .done(function(response) {
                        if (response.success === true) {
                            outputDaysCells(m, y, ( response.daysNotEmpty && response.daysNotEmpty.length > 0 ) ? response.daysNotEmpty : [] );
                        } else {
                            if (!isInit) {
                                $(document).trigger('is:errorModal', errData);
                            }
                        }
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        if (!isInit) {
                            $(document).trigger('is:errorModal', errData);
                        }
                    });
            }
            
            function outputDaysCells (m, y, arActive = []) {
                let mFormatted = m + 1;
                const q = getDaysQuantity(mFormatted, y);
                
                const dateStr = y + "-" + ((mFormatted < 10 ) ? "0"+mFormatted : ""+mFormatted) + "-01";
                const firstDay = new Date(dateStr).getDay();
                const spaces = (firstDay !== 0) ? firstDay - 1 : 6;
                
                const nowDate = new Date();
                const nowD = nowDate.getDate();
                const nowM = nowDate.getMonth();
                const nowY = nowDate.getFullYear();
                
                let isCurrent = false;
                let isFuture = false;
                let isPast = false;
                
                if (nowY === y && nowM === m) {
                    // текущий месяц и год
                    isCurrent = true;
                } else if ( (nowM < m && nowY <= y) || (nowY < y) ) {
                    // будущий месяц этого года или будущий год
                    isFuture = true;
                } else {
                    // прошлое
                    isPast = true;
                }
                
                let hasActive = false;
                
                if (y === curYear && m === curMonth) {
                    hasActive = true;
                }
                
                let html = "";
                
                for (let i = 1; i <= spaces; i++) {
                    html += "<span class=\"b-calendar__days-body--cell _empty\"></span>";
                }
                
                for (let j = 1; j <= q; j++) {
                    let addClasses = "";
                    
                    if (hasActive && j === curDay) {
                        addClasses += " _chosen";
                    }
                    
                    if (arActive.includes(j)) {
                        addClasses += " _has-events";
                    }
                    
                    if (isCurrent) {
                        if (j === nowD) {
                            addClasses += " _today";
                        } else if (j > nowD) {
                            addClasses += " _future";
                        } else {
                            addClasses += " _passed";
                        }
                    } else if (isFuture) {
                        addClasses += " _future";
                    } else if (isPast) {
                        addClasses += " _passed";
                    }
                    
                    if (isCurrent && nowD === j) {
                        addClasses += " _today";
                    }
                    
                    html += "<span class=\"b-calendar__days-body--cell\"><span class=\"b-calendar__days-body--cell---day js-calendar__days-cells--item" + addClasses + "\" data-day-num=\"" + j + "\">" + j + "</span></span>";
                }
                
                $daysContainer.html(html);
            }
    
            function getDaysQuantity (mNum, yNum) {
                const days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                const mNumInt = +mNum;
                const yNumInt = +yNum;
        
                let daysQ = days[mNumInt - 1];
        
                if (mNumInt === 2 && new Date(yNumInt, mNumInt - 1, 29).getMonth() === 1) daysQ++;
        
                return daysQ;
            }
            
        });
    })
}());
